module.exports = __webpack_public_path__ + "img/pic_news_bottom@2x.21e564c2.png";